import type {
    WebSkillListParams,
    WebSkillListResponse,
    WebSkillDetailItem,
    WebSkillCreateRequest,
    WebSkillCreateData,
    WebSkillEnableData,
    WebSkillDeleteData,
} from '../types';

export const SkillApiService = Symbol('SkillApiService');

export interface SkillApiService {
    getList(params?: WebSkillListParams): Promise<WebSkillListResponse>;
    getDetail(name: string): Promise<WebSkillDetailItem>;
    create(data: WebSkillCreateRequest): Promise<WebSkillCreateData>;
    enable(name: string): Promise<WebSkillEnableData>;
    disable(name: string): Promise<WebSkillEnableData>;
    remove(name: string): Promise<WebSkillDeleteData>;
}
